import { BlockItem } from "@/models/Blocks/Itens/block-item";

export interface TemplateStructCol{
    width?: number;
    itens: Array<BlockItem|TemplateStruct>;
}

export interface TemplateStructRow{
    cols: Array<TemplateStructCol>;
}

export interface TemplateStructData{
    rows: Array<TemplateStructRow>;
}

export class TemplateStruct implements TemplateStructData{
    protected _rows:  Array<TemplateStructRow> = new Array<TemplateStructRow>();
    protected _key?: string;
    protected _cols: number = 12;
    protected _height?: number;

    public constructor(){
        this._rows = new Array<TemplateStructRow>();
    }

    public get rows(): Array<TemplateStructRow>{
        return this._rows;
    }

    public set rows(rows: Array<TemplateStructRow>){
        this._rows = rows;
    }

    public get key(): string|undefined{
        return this._key;
    }

    public set key(value: string){
        this._key = value;
    }

    public set cols(value: number){
        this._cols = value;
    }

    public get cols(): number{
        return this._cols;
    }

    public get height(): number|undefined{
        return this._height;
    }

    public set height(value: number) {
        this._height = value;
    }

    public clone(): TemplateStruct{
        let cloneObj = new TemplateStruct();
        cloneObj.rows = [...this._rows];
        return cloneObj;
    }
}